import "./App.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import TreatmentPlanInfo from "./treatmentPlanInfo";

function App() {
  return <TreatmentPlanInfo />;
}

export default App;
